import * as React from "react";
import NumberFormat from "react-number-format";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/styles";
import { SxProps, Theme } from "@mui/system";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumberFormatCustom = React.forwardRef<NumberFormat<any>, CustomProps>(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      fixedDecimalScale
      decimalScale={2}
      prefix="$"
    />
  );
});

export interface MaskedInputState {
  amountOwed: string;
  securityDeposit: string;
  misc: string; // default
}

export interface MaskedInputPropsType {
  label: string;
  placeholder?: string;
  values: MaskedInputState | string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  id?: string;
  onBlur?: (e: any) => void;
  disabled?: boolean;
  error?: boolean;
  sx?: SxProps<Theme>;
}

const extractApproppriateValue = (map: any, name: string) => {
  if (typeof map === 'object') return map[name];

  return map;
};

export default function MaskedInput(props: MaskedInputPropsType) {
  const { handleChange, ...relevantProps } = props;
  return (
    <TextField
      {...relevantProps}
      value={extractApproppriateValue(props.values, props.name)}
      onChange={props.handleChange}
      InputProps={{
        inputComponent: NumberFormatCustom as any,
      }}
      variant="outlined"
      disabled={props.disabled}
      error={props.error}
      sx={props.sx}
    />
  );
}

export const StyledMaskedInput = styled(MaskedInput)<MaskedInputPropsType>(({ theme }) => ({
  width: '105px',
  "& .MuiOutlinedInput-root": {
    background: "white",
    height: "33px",
    borderRadius: "24px",
    border: "none",
    color: "#000",
  },
  "& .MuiOutlinedInput-root>input": {
    textAlign: "center",
  },
}));
